<template>
    <div class="login-box" style="min-width: 1200px;">
        <RMTopDiv :scroll100="scroll100" :scroll700="scroll700"></RMTopDiv>
        <div style="margin-left: 15%;width: 70%;">
            <div style="width: 100%;position: relative;overflow: hidden;">
                <img :src="model.img" style="width: 100%;height: 500px;" alt="" class="img_class">
                <div style="position: absolute;color: white;width: 100%;text-align: center;top: 40%;">
                    <div style="font-size: 60px;">{{model.content.title}}</div>
                    <div style="font-size: 40px;margin-top: 40px;">{{model.content.address}}</div>
                </div>
                
            </div>
            <div>
                <div class="div_conter_text">{{model.content.content_one}}</div>
                <div style="width: 100%;">
                    <img :src="model.content.img" style="width: 100%;height: 100%;" alt="">
                </div>
                <div style="margin-top: 14px;">
                    <div class="div_conter_text_two" v-for="(item, index) in model.content.content_two" :key="index">{{item}}</div>
                </div>
            </div>
            <div style="padding: 40px 0px;font-size: 14px;color: #444444;">
                <div>
                    <span style="background: rgb(242, 243, 244);padding: 3px 5px;">上一篇</span>
                    <span>{{model.content.title_up}}</span>
                </div>
                <div style="margin-top: 20px;">
                    <span style="background: rgb(242, 243, 244);padding: 3px 5px;">下一篇</span>
                    <span>{{model.content.title_down}}</span>
    
                </div>
            </div>
        </div>
        
        <!-- 尾部 -->
        <RMBottomDiv></RMBottomDiv>
    </div>
</template>
<script>
    import RMTopDiv from '../../src/page/RMTopDiv.vue'
    import RMBottomDiv from '../../src/page/RMBottomDiv.vue';
    export default {
        data() {
            return {
                scroll: '',
                scroll100: false,
                scroll700: true,
                model:{},
            }
        },
        mounted() {
            //获取高度
            window.addEventListener("scroll", this.dataScroll, true);
            //获取上个界面传过来的值
            this.model = JSON.parse(this.$route.query.model);
            console.log(this.model);
        },
        methods: {
            // dataScroll(event) {
            //     this.scroll = document.documentElement.scrollTop || document.body.scrollTop || event.target.scrollTop
            // },
            // loadSroll: function () {
            //     if (this.scroll <= 100) {
            //         this.scroll100 = true
            //     } else {
            //         this.scroll100 = false
            //     }
            //     if (this.scroll > 100) {
            //         this.scroll700 = true
            //     } else {
            //         this.scroll700 = false
            //     }
            // },
        },
        components:{
            RMBottomDiv,
            RMTopDiv

        },
        watch: {
            scroll: function () {
                this.loadSroll();
            }
        },
    }
</script>
<style scoped>
    .login-box {
        width: 100%;
        height: 100%;
        position: fixed;
        background: #fff;
        overflow-y: auto;
    }
    .div_conter_text{
        font-size: 18px;
        font-weight: 400;
        line-height: 40px;
        margin: 14px 0px;
        white-space: pre-line;
        text-indent: 2em;
    }
    .div_conter_text_two{
        font-size: 18px;
        font-weight: 400;
        line-height: 40px;
        /* margin: 28px 0px; */
        white-space: pre-line;
        text-indent: 2em;
    }
    .img_class{
        -webkit-filter: blur(30px);
        filter: blur(30px);
    }
    
</style>


// WEBPACK FOOTER //
// src/page/RMBrand_Details.vue